import script from "./DeviceManager.vue?vue&type=script&setup=true&lang=ts"
export * from "./DeviceManager.vue?vue&type=script&setup=true&lang=ts"

import "./DeviceManager.vue?vue&type=style&index=0&id=2ba21e82&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ba21e82"]])

export default __exports__